// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q7i0","left":"styles_left__3zZ6R"};